import { createSafeContext } from '@/package';

import type { ToolPlayControllerContextValue } from './type';

const ToolPlayControllerContext =
  createSafeContext<ToolPlayControllerContextValue>(
    null,
    'ToolPlayControllerContext',
  );

export default ToolPlayControllerContext;
